import { ActionType, AuthActions } from '../actions/authActions';
import { getLocalStorageItem, } from '../utility/helper';

export interface AuthState {
  token: string;
  refreshToken: string;
  uid:  string;
  email: string;
  firstName: string;
  lastName: string;
}

const getStoredToken = (): string => {
  const token = getLocalStorageItem('token');
  if (!token) return '';
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp * 1000 < Date.now()) {
      localStorage.clear();
      return '';
    }
    return token;
  } catch {
    localStorage.clear();
    return '';
  }
};

const storedToken = getStoredToken();

export const initialState: AuthState = {
  token : storedToken,
  refreshToken: storedToken ? getLocalStorageItem('refreshToken') : '',
  uid: storedToken ? getLocalStorageItem('uid') : '',
  email: storedToken && getLocalStorageItem('email') ? getLocalStorageItem('email') : '',
  firstName: storedToken && getLocalStorageItem('firstName') ? getLocalStorageItem('firstName') : '',
  lastName: storedToken && getLocalStorageItem('lastName') ? getLocalStorageItem('lastName') : ''
};

const authReducer = (state: AuthState, action: AuthActions): AuthState => {
  switch (action.type) {
    case ActionType.LOGIN:
      return {
        ...state,
        token : action.payload.token,
        refreshToken : action.payload.refreshToken,
        uid: action.payload.uid,
        email: action.payload.email,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName
      };
    case ActionType.LOGOUT:
      return {
        ...state,
        token : '',
        refreshToken: '',
        uid: ''
      };
    default:
      return state;
  }
};

export default authReducer;